<template>
    <div v-if="enableSetting" class="dib">
        <div @click="showSetting = true" class="cusr dib">
            <el-badge :value="nodeInfo" :type="isOutDate ? 'danger' : 'warning'">
                <i class="el-icon-setting"></i>
            </el-badge>
        </div>
        <el-dialog
            :custom-class="style"
            title="节点设置 / 切换节点"
            modal-append-to-body
            :visible.sync="showSetting"
            class="dialog-box">
            <el-form>
                <el-button
                    type="primary"
                    v-clipboard:copy="copyUrl"
                    v-clipboard:success="copySuccess"
                >复制链接</el-button>
                <h4>当前节点版本号：{{nodeVersion}}
                    <span :class="{synchro:state === '已同步',unsynchro:state === '未同步'}">{{state}}</span>
                </h4>
                <!-- <h4 v-if="isOutDate" class="text-danger tips">⚠️ 区块链浏览器适配的版本号是 {{browserApiVersion}}</h4> -->
                <el-form-item label="provider" :label-width="formLabelWidth">
                    <el-select
                        popper-class="provider-select"
                        v-model="tmpProvider"
                        filterable
                        allow-create
                        default-first-option
                        @change="providerMatchExecer"
                        placeholder="please choose provider">
                        <el-option
                        v-for="(item,index) in providerOptions"
                        :key="index"
                        :label="item.label"
                        :value="item.value">
                            <p class="option-name">{{item.label}}</p>
                            <p class="option-value">{{item.value}}</p>
                            <i class="iconfont icon-minus-bold set-del" @click.stop="delNodesSet(item)" v-if="item.execer"></i>
                        </el-option>
                    </el-select>
                    <i class="iconfont icon-jiahaocu" @click="showAddBox = true"></i>
                    <p class="tips">* provider 是指提供接口的节点地址</p>
                </el-form-item>
                <el-form-item label="execer" :label-width="formLabelWidth">
                    <el-select
                        v-model="tmpExecer"
                        filterable
                        allow-create
                        default-first-option
                        placeholder="please choose execer">
                        <el-option
                        v-for="(item,index) in execerOptions"
                        :key="index"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                    <i class="iconfont icon-jiahaocu" @click="showAddBox = true"></i>
                    <p class="tips">* execer 是执行器，在查询账户余额相关接口使用，平行链的执行器格式为user.p.xxx.token</p>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showSetting = false">取 消</el-button>
                <el-button type="primary" @click="applySetting">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 添加节点 -->
        <el-dialog
          :custom-class="addStyle"
          top="25vh"
          class="addnodes-box"
          title="添加节点"
          :visible.sync="showAddBox"
          width="500px"
          center>
          <el-form class="addForm" :model="addForm" ref="addForm" :rules="addRules">
            <el-form-item prop="label" :rules="[{ required: true, message: '节点名不能为空', trigger: 'blur' }]">
              <el-input placeholder="请输入节点名" v-model="addForm.label">
                <template slot="prepend">name</template>
              </el-input>
            </el-form-item>
            <el-form-item prop="value">
              <el-input placeholder="请输入节点地址" v-model="addForm.value">
                <template slot="prepend">provider</template>
              </el-input>
            </el-form-item>
            <el-form-item prop="execer">
              <el-input placeholder="请输入执行器" v-model="addForm.execer">
                <template slot="prepend">execer</template>
              </el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="addNodesSet()">确 定</el-button>
            <el-button @click="showAddBox = false">取 消</el-button>
          </span>
        </el-dialog>
    </div>
</template>
<script>
    const enableSetting = (process.env.VUE_APP_IS_DYNAMIC === 'true')
    import { checkURL } from '@/assets/js/filters.js'
    import {checkIsMobile} from '@/assets/js/common.js'
    import nodeVersion from '@/mixins/nodeVersion'
    import defaultOptions from '@/config/providers.js'

    export default {
        mixins: [nodeVersion],
        data () {
            var checknode = (rule,value,callback) => {
                if(!value) return callback(new Error('provider不能为空'))
                else {
                    if(!checkURL(value)) return callback(new Error('provider不符合url格式'))
                    else{
                        this.providerOptions.map(current => {
                            if(current.value === value) return callback(new Error('该provider已存在'))
                        })
                        return callback()
                    }
                }
            }
            var checkexecer = (rule,value,callback) => {
                if(!value) return callback(new Error('execer不能为空'))
                else{
                    if(value!=='token'&& !/^user\.p\.\w+\.token$/.test(value)) return callback(new Error('execer必须为token或user.p.xxx.token格式'))
                    else return callback()
                }
            }
            return {
                isMobile:false,
                style:'setting-dialog',
                enableSetting: enableSetting,
                showSetting: false,
                showAddBox: false,
                formLabelWidth: '120px',
                tmpProvider: '',
                tmpExecer: '',
                providerOptions: defaultOptions,
                execerOptions: [
                    'token',
                    'user.p.guodun.token'
                ],
                copyUrl:'',
                state: '未同步',
                addForm: {
                    value:'',
                    label:'',
                    execer:'',
                    id:0
                },
                addStyle: 'add-dialog',
                addRules: {
                    value: [
                        { validator: checknode, trigger: 'blur' }
                    ],
                    execer: [
                        { validator: checkexecer, trigger: 'blur' }
                    ]
                }
            }
        },
        computed: {
            provider () {
                return this.$store.state.apiSetting.provider
            },
            execer () {
                return this.$store.state.apiSetting.execer
            },
            nodeInfo () {
                // 取label
                let nameInWord = this.providerOptions.find( item => item.value === this.provider )
                if ( nameInWord ){
                    nameInWord = nameInWord.label
                } else {
                    // 取域名
                    let nameInHost = this.provider.match(/\/\/(.*?)\//)
                    if (nameInHost !== null && nameInHost[1] ) {
                        nameInWord = nameInHost[1]
                    }
                }
                // 都取不到则原文展示
                if (!nameInWord) {
                    nameInWord = this.provider
                }
                
                if ( this.isOutDate ) {

                    return `${nameInWord} v${this.nodeVersion} ⚠️`
                } else {

                    return `${nameInWord} v${this.nodeVersion || '...'}`
                }
            },
        },
        watch: {
          $route() {
              this.shareUrl()
          },
          showAddBox(val) {
              if(val===false) this.$refs['addForm'].resetFields();
          }
        },
        mounted(){
            this.addlocalSet()
            this.shareUrl()
            this.tmpProvider = this.provider
            this.tmpExecer = this.execer
            this.checkMobile()
            this.checks()
        },
        methods: {
            // 删除配置节点
            delNodesSet(val) {
                this.$confirm(`您确定要删除  ${val.label}  节点吗？`,'提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$store.commit('delNodesOptions',val)
                    this.addlocalSet()
                    this.tmpProvider = defaultOptions[0].value
                    this.tmpExecer = this.execerOptions[0]
                    this.$message.success('删除成功!')
                }).catch(() => {
                    this.$message.info('已取消删除')
                })
            },
            // 添加配置节点
            addNodesSet() {
                this.$refs['addForm'].validate(valid => {
                    if(valid){
                        this.$store.commit('addNodesOptions',this.addForm)
                        this.showAddBox = false
                        this.addlocalSet()
                        this.$message.success('添加成功')
                    }else{
                        this.$message.error('添加失败，请检查数据')
                    }
                })
            },
            // 加载本地节点配置
            addlocalSet() {
                let nodesList = JSON.parse(this.$store.state.nodesList)
                this.providerOptions = [...defaultOptions,...nodesList]
                nodesList.map(current => {
                    if(!this.execerOptions.includes(current.execer)) this.execerOptions.push(current.execer)
                })
            },
            // provider匹配execer
            providerMatchExecer(val) {
                this.providerOptions.map(current => {
                    if(current.value === val)
                        this.tmpExecer = current.execer || 'token'
                })
            },
            // share Provider/execer/param
            shareUrl(){
                let hasParam = ''
                if(location.search!==''){
                    hasParam = '&provider='
                }else{
                    hasParam = '?provider='
                }
                this.copyUrl = location.href+hasParam+encodeURIComponent(this.provider)+'&execer='+encodeURIComponent(this.execer)
            },
            // 检测打开设备
            checkMobile(){
                this.isMobile = checkIsMobile()
                if(this.isMobile!==false){
                    this.formLabelWidth='20vw'
                    this.style = 'setting-dialog-m'
                    this.addStyle = 'add-dialog-m'
                }else{
                    this.formLabelWidth='120px'
                    this.style = 'setting-dialog'
                    this.addStyle = 'add-dialog'
                }
            },
            applySetting () {
                // 应用修改
                this.$store.commit('updateApiSetting', {
                    provider: this.tmpProvider,
                    execer: this.tmpExecer,
                })
                this.$router.push('/index')
                location.reload()
            },
            copySuccess(){
                this.$notify({
                  title: "提示",
                  message: '复制成功',
                  type: "success"
                });
            },
            // 检测节点同步状态
            // checkStatus () {
            //     this.$chain33Rpc.getPeerInfo().then(data => {
            //         if (data.error == null) {
            //             let dataArr = data.result.peers;
            //             this.state.peercount = dataArr.length;
            //             if (dataArr.length < 1) {
            //                 //小于一个节点个数情况
            //                 this.state.info = "节点数小于1";
            //                 this.state.rate = 0;
            //             } else {
            //                 let max = 0;
            //                 dataArr.map(current => {
            //                     max = max >current.header.height? max:current.header.height
            //                 })
            //                 this.$chain33Rpc.getLastHeader().then(res => {
            //                     if (data.error == null) {
            //                         let lastHeight = res.result.height
            //                         if (max - lastHeight < 3) {
            //                             this.state.info = "已同步到最新高度";
            //                             this.state.rate = 100;
            //                         } else {
            //                             this.state.info = "未同步完成";
            //                             this.state.rate = parseInt(lastHeight / max * 100);
            //                         }
            //                     }else {
            //                         this.$notify({
            //                           title: "提示",
            //                           message: data.error,
            //                           type: "warning"
            //                         });
            //                     }
            //                 })
            //             }
            //         } else {
            //           this.$notify({
            //             title: "提示",
            //             message: data.error,
            //             type: "warning"
            //           });
            //         }
            //     })
            // },
            checks() {
                this.$chain33Rpc.isSync().then(data => {
                    if (data.error === null) {
                        if (data.result) this.state = '已同步'
                        else this.state = '未同步'
                    } else {
                      this.$notify({
                        title: "提示",
                        message: data.error,
                        type: "warning"
                      });
                    }
                })
            }
        }
    }
</script>
<style lang="scss">
.el-badge{
    line-height: 1;
    .el-badge__content{
        border: 0 none;
        font-weight: 400;
    }
    .el-icon-setting{
        font-size:18px;
        color:#DADADA;
    }
}
.setting-dialog{
    .el-select{
        width: 100%;
    }
    .el-form-item{
        width: 92%;
    }
}
.setting-dialog-m{
    width: 90%!important;
    .el-select{
        width: 100%;
    }
    .el-form-item{
        width: 92%;
    }
}
.add-dialog{
    .el-form-item{
        margin-bottom: 30px;
    }
    .el-dialog__footer{
        padding-top: 0;
    }
    .el-form-item__error{
        left: 40%;
    }
}
.add-dialog-m{
    // margin-top:35vw!important; 
    width: 90%!important;
}
.dib .tips{
    text-align: left;
    line-height: 1.2;
    margin: 6px 0;
}
.unsynchro{
    margin-left: 15px;
    color: #f56c6c;
}
.synchro{
    margin-left: 15px;
    color: #1d953f;
}
.option-name,
.option-value{
    line-height: 1.4;
}
.option-value{
    display: inline-block;
}
.set-del{
    float: right;
    margin-right: 1em;
    color:#606266;
    font-weight: bold;
}
.set-del:hover{
    color:#DEB142;
}
.option-name{
    font-size: 12px;
    color: $day_font_blue;
}
.option-value{
    font-size: 14px;
}
.dib .dialog-box::-webkit-scrollbar {
    display: none;
}
.dib .el-form-item{
    position: relative;
    .icon-jiahaocu{
        position: absolute;
        right: -30px;
    }
    .icon-jiahaocu:hover{
        cursor: pointer;
        color: #DEB142;
    }
}
.dib .el-input-group__prepend{
  width: 110px;
}
</style>
